import CustomerRepository    from "../../../domain/customer/CustomerRepository";
import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import CustomerDataSource    from "../../../infrastructure/datasource/customer/CustomerDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";

class ImportCustomer {
  private readonly repository: CustomerRepository = new CustomerDataSource(this.dispatch);
  private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(this.dispatch);
  private readonly notifyRepository: NotifyRepository = new NotifyDataSource(this.dispatch);

  constructor(private readonly dispatch) {
  }

  public async execute(csvData: {}, callback: (value: string) => void) {
    this.fetchStatusRepository.start();
    try {
      await this.repository.import(csvData);
      callback("");
      this.notifyRepository.saveSuccess();
    } catch (e) {
      callback("顧客情報のインポートができませんでした。対応しているCSV形式かご確認ください。");
      this.notifyRepository.saveFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default ImportCustomer;
